import { useEffect, useRef } from "react";
import { useSession } from "../session/SessionContext.js";
import { setProductEventContext, track } from "./product-events.js";

const SESSION_KEY = "evolua.telemetry.session.started";

/** Liga contexto de sessão + `session.started` (uma vez por aba/usuário). */
export function SessionTelemetry() {
  const { session } = useSession();
  const lastKey = useRef<string | null>(null);

  useEffect(() => {
    if (!session) {
      setProductEventContext(null);
      return;
    }

    setProductEventContext({
      tenantId: session.companyId,
      userId: session.userId,
      role: String(session.role),
    });

    const key = `${session.userId}:${session.companyId}`;
    if (lastKey.current === key) return;
    lastKey.current = key;

    const storageKey = `${SESSION_KEY}:${key}`;
    if (sessionStorage.getItem(storageKey) === "1") return;
    sessionStorage.setItem(storageKey, "1");
    track("session.started");
  }, [session]);

  return null;
}
